import { useTranslations } from 'use-intl';

import { TheySaidLogoIcon } from '@/shared-ui';

export default function SurveyAiFormsPoweredBy() {
  const t = useTranslations('AIForms.poweredBy');

  return (
    <div
      data-test='powered-by'
      className='flex h-8 w-full items-center justify-center gap-1 bg-white'
    >
      <div className='text-xs/3 font-normal text-black'>{t('label')}</div>

      <div>
        <TheySaidLogoIcon width={44} height={10} />
      </div>

      <div className='text-xs text-black'>
        <a
          href='https://www.theysaid.io/'
          className='cursor-pointer text-black underline transition-colors'
        >
          {t('tryItForFree')}
        </a>
        <span className='mx-1'>|</span>
        <a
          href='https://www.theysaid.io/terms'
          className='cursor-pointer text-black underline transition-colors'
        >
          {t('termsOfUse')}
        </a>
      </div>
    </div>
  );
}
